import { FC, ReactElement } from 'react';

import { i18n } from '$/components/core/Localization/18n';
import { de } from '$/translations/de';

interface Props {
  children: ReactElement;
}

export const LocalizationProvider: FC<Props> = ({ children }) => {
  if (!i18n.isInitialized) {
    void i18n.init({ lng: 'de', debug: true, resources: { de } });
  }

  return children;
};
